import React from 'react'
import MapBlock from '../components/PageBlock/MapBlock'

const Contact = ({ data }) => {
  const { node } = data

  const address = node.address[0].text
  const email = node.email[0].text
  const phone = node.phone[0].text
  const phoneLink = phone.replace(/\D+/g, '').substr(2)

  return (
    <div className="page">
      <div className="container">
        <div className="page--block page--block__contact">
          <h2>{address}</h2>
          <a href={`tel:${phoneLink}`}>{phone}</a>
          <a href={`mailto:${email}`}>{email}</a>
        </div>
        <div className="page--block page--block__map">
          <MapBlock address={address} />
        </div>
      </div>
    </div>
  )
}

export default Contact
